import "./App.css";
import Home from "./pages/Home";
import Header from "./components/Header";
import HomeContent from "./components/HomeContent";
import { Outlet } from "react-router-dom";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default App;
